import { Component, EventEmitter, Input, OnInit, Output, ViewChild, HostListener } from '@angular/core';
import { SharedService } from '../shared.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { DialerService } from '../dialer.service';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-dial',
  templateUrl: './dial.component.html',
  styleUrl: './dial.component.scss'
})
export class DialComponent implements OnInit {
  @ViewChild('callingModal') callingModal!: ModalDirective;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() dial?: any;
  alert_data_store: any = [];
  smaller: boolean = false;
  modalRef?: BsModalRef;
  openSmall: boolean = false;
  showmodal: boolean = true;
  openSummaryModal: boolean = false;
  dialed_number: string = '';
  call_sid: any = '';
  eConsent_value: any = false;

  constructor(
    public _shared: SharedService,
    public _api: ApiService,
    private router: Router,
    public dialer: DialerService,
  ) { }

  patient_name_innitials = '';
  patient_mobile = '';
  relations: string[] = [
    'PRIMARY',
    'BROTHER',
    'FATHER',
    'MOTHER',
    'SISTER',
    'SPOUSE',
    'OTHER'
  ];
    statusOptions = [
    { value: 'pending', label: 'PENDING', icon: 'assets/images/icons/pendingicon.svg' },
    { value: 'not_verified', label: 'NOT VERIFIED', icon: 'assets/images/icons/cross-circle.png' },
    { value: 'verified', label: 'VERIFIED', icon: 'assets/images/svg/checktick.svg' },
    { value: 'dnd', label: 'DND', icon: 'assets/images/icons/dnd.svg' }
  ];

    status: string =   this.dialer.verificationStatus === 1
    ? 'verified'
    : this.dialer.verificationStatus === 2
    ? 'not_verified'
    :
    this.dialer.verificationStatus === 3
    ? 'DND' 
    :'pending';
  initialStatus: string = '';
  statusValue: number = this.dialer.verificationStatus || 0;
  // relationTag: string = 'Primary';
  relationTag: string = this.dialer.relation ? this.dialer.relation.toUpperCase() : 'PRIMARY';
  isDefault: boolean = false;
  notes: string = '';
  eConsent: any = false;

  get isContactPersonRelation(): boolean {
    const relation = (this.dialer.relation || this.relationTag || '').toString().toLowerCase().trim();
    return relation === 'contact person';
  }

  // Dropdown Visibility States
  isStatusOpen: boolean = false;
  isRelationOpen: boolean = false;
  ngOnInit(): void {
    if (this.dialer.patientName) {
      const parts = this.dialer.patientName.trim().split(" ");
      this.patient_name_innitials = parts
        .map(p => p[0]?.toUpperCase())
        .join("");
    }
    this.openSmall = false;
    this.initialStatus = this.status;
    this.eConsent_value = !!Number(this.dialer.e_consent);
    this.eConsent = this.eConsent_value;
  }

  ToggleMinimize() {
    this.openSmall = true;
  }
  ToggleMaximize() {
    this.openSmall = false;
  }

  callended() {
    this.dialer.onHangupClick();
    setTimeout(() => {
      console.log(this.dialer.openSummaryModal, this.dialer.call_sid, this.dialer.selectedRecipientNumber, "openSummaryModal>>>");
      this.openSummaryModal = this.dialer.openSummaryModal;
      this.call_sid = this.dialer.call_sid;
      this.dialed_number = this.dialer.selectedRecipientNumber
    }, 1000);
    
  }

 


  // Status definitions


  // Logic for Status Dropdown
  toggleStatus() {
    this.isStatusOpen = !this.isStatusOpen;
    if (this.isStatusOpen) this.isRelationOpen = false; // Close other
  }

  selectStatus(val: string) {
    if (val === 'pending' && this.initialStatus !== 'pending') {
      return;
    }

    this.status = val;
    this.isStatusOpen = false;
    switch (val) {
      case 'pending':
        this.statusValue = 0;
        break;
      case 'not_verified':
        this.statusValue = 2;
        break;
      case 'verified':
        this.statusValue = 1;
        break;
      case 'dnd':
        this.statusValue = 3;
        break;
      default:
        this.statusValue = 0;
    }
  }

  // Logic for Relation Dropdown
  toggleRelation() {
    this.isRelationOpen = !this.isRelationOpen;
    if (this.isRelationOpen) this.isStatusOpen = false; // Close other
  }

  selectRelation(val: string) {
    this.relationTag = val;
    this.isRelationOpen = false;
  }

  toggleDefault() {
    this.isDefault = !this.isDefault;
    console.log('isDefault value:', this.isDefault);
  }

  saveDetails() {
    const payload = {
      phone_number: this.dialed_number || this.dialer.selectedRecipientNumber,
      call_sid: this.call_sid || this.dialer.call_sid,
      status: this.statusValue,
      relation: this.relationTag,
      is_default: (this.statusValue === 2 || this.statusValue === 3) ? 0 : (this.isDefault ? 1 : 0),
      e_consent: this.eConsent ? 1 : 0,
      is_contact_person: this.isContactPersonRelation ? 1 : 0,
      split_req_id: this.dialer.split_req_id,
      notes: this.notes.trim(),
    };
    console.log('Saving Details:', payload);
    this._api.api(payload, 'finance/update_call_summary').subscribe((res) => {
      this.dialer.notifyCallSummarySaved(this.dialer.split_req_id);
      this.resetForm();
      this.dialer.openSummaryModal = false;
      this.dialer.showIcomming = false;
      this.passEntry.emit({ success: true });
    })

    // Add your API call here
  }
  resetForm() {

    this.status = 'pending';
    this.statusValue = 0;
    this.relationTag = 'Primary';
    this.isDefault = false;
    this.notes = '';
    this.isStatusOpen = false;
    this.isRelationOpen = false;
    console.log('Form cleared and reset to defaults');
  }

  showKeypad: boolean = false;

  /** IVR keypad layout, laid out 3 per row by the grid in the stylesheet. */
  keypadKeys: { digit: string; letters: string }[] = [
    { digit: '1', letters: '' },
    { digit: '2', letters: 'ABC' },
    { digit: '3', letters: 'DEF' },
    { digit: '4', letters: 'GHI' },
    { digit: '5', letters: 'JKL' },
    { digit: '6', letters: 'MNO' },
    { digit: '7', letters: 'PQRS' },
    { digit: '8', letters: 'TUV' },
    { digit: '9', letters: 'WXYZ' },
    { digit: '*', letters: '' },
    { digit: '0', letters: '+' },
    { digit: '#', letters: '' },
  ];

  toggleKeypad() {
    this.showKeypad = !this.showKeypad;
  }

  /** Called from the minimized bar: expand the modal straight onto the keypad. */
  openKeypad() {
    this.showKeypad = true;
    this.smaller = false;
    this.openSmall = false;
  }

  /** Let the admin type the IVR options instead of clicking them. */
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.showKeypad || this.openSmall || event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    const target = event.target as HTMLElement | null;
    const tag = target?.tagName?.toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || target?.isContentEditable) {
      return;
    }
    if (/^[0-9*#]$/.test(event.key)) {
      event.preventDefault();
      this.dialer.sendDigit(event.key);
    }
  }

}
